import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {RemoveNovaAgentFileInput, RemoveNovaAgentFileMutation} from './__generated__/RemoveNovaAgentFileMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// Removing a file drops its record (and its {file:...} variable) and deletes the stored object. The
// response carries the refreshed agent so the store updates by id; the caller re-runs its on-demand
// detail fetch as well, and any prompt still referencing the removed token then reads as a broken
// reference (see novaInputValidation).
const mutation = graphql`
	mutation RemoveNovaAgentFileMutation($input: RemoveNovaAgentFileInput!) {
		removeNovaAgentFile(input: $input) {
			agent {
				id
				files {
					fileId
					filename
					variableToken
					processingStatus
					sizeBytes
					mimeType
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<RemoveNovaAgentFileInput>,
	onSuccess?: RelayOnCompleted<RemoveNovaAgentFileMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<RemoveNovaAgentFileMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
